<template>
  <div>
    <v-menu offset-y left transition="slide-y-transition">
      <template v-slot:activator="{ on, attrs }">
        <v-btn icon v-bind="attrs" v-on="on" style="max-width: 42px;">
          <v-icon>{{ modeIcon }}</v-icon>
        </v-btn>
      </template>
      <v-list dense>
        <v-list-item
          v-for="option in options"
          :key="option.value"
          :input-value="themeMode === option.value"
          @click="selectMode(option.value)"
        >
          <v-list-item-icon class="mr-3">
            <v-icon>{{ option.icon }}</v-icon>
          </v-list-item-icon>
          <v-list-item-title>{{ $t(option.label) }}</v-list-item-title>
          <v-list-item-icon v-if="themeMode === option.value">
            <v-icon small color="primary">mdi-check</v-icon>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

export default {
  data() {
    return {
      options: [
        { value: 'os', icon: 'mdi-theme-light-dark', label: 'theme.os' },
        { value: 'light', icon: 'mdi-weather-sunny', label: 'theme.light' },
        { value: 'dark', icon: 'mdi-weather-night', label: 'theme.dark' },
      ],
    };
  },
  computed: {
    ...mapState('app', ['themeMode']),
    modeIcon() {
      const current = this.options.find((o) => o.value === this.themeMode);

      return current ? current.icon : 'mdi-theme-light-dark';
    },
  },
  methods: {
    ...mapActions('app', ['setThemeMode']),
    selectMode(mode) {
      this.setThemeMode(mode);
    },
  },
};
</script>
